import { getSubscriptionDetails } from "../../pages/admin/Subscriptions/helper";
import dayjs from "../../utils/dayjs";

export const setCurrentPlans = (state, action) => {
  const { latest_subscription, previous_subscription } = action.payload;

  if (!previous_subscription) {
    state.currentPlan = latest_subscription;
    return;
  }

  const latestPlan = getSubscriptionDetails(latest_subscription)?.selectedPlan;

  const previousPlan = getSubscriptionDetails(
    previous_subscription,
  )?.selectedPlan;

  const latestAmount = Number(latestPlan?.price?.unit_price?.amount || 0);

  const previousAmount = Number(previousPlan?.price?.unit_price?.amount || 0);

  const now = dayjs();

  const isPreviousSubscriptionActive =
    previous_subscription?.status === "canceled" &&
    now.isAfter(
      dayjs(previous_subscription?.db_current_billing_period?.starts_at),
    ) &&
    now.isBefore(
      dayjs(previous_subscription?.db_current_billing_period?.ends_at),
    );

  const isDowngrade =
    isPreviousSubscriptionActive &&
    latestAmount !== previousAmount &&
    latestAmount < previousAmount;

  state.currentPlan = isDowngrade ? previous_subscription : latest_subscription;
  state.planNote = isDowngrade
    ? `Your canceled ${previousPlan?.name} plan includes more features and benefits than the ${latestPlan?.name} plan. You still have ${
        dayjs(previous_subscription?.db_current_billing_period?.ends_at).diff(
          dayjs(),
          "day",
        ) || 1
      } days remaining on your canceled plan, so you will continue to have access until ${dayjs(
        previous_subscription?.db_current_billing_period?.ends_at,
      ).format(
        "DD MMM YYYY",
      )}. After that, your subscription will automatically switch to the ${latestPlan?.name} plan.`
    : null;
};
